import * as React from "react";
import { Spinner, SpinnerProps } from "@origin-digital/style-guide";
import { Box, Card } from "@origin-digital/ods-core";

export const Loading = ({ size }: { size?: SpinnerProps["size"] }) => (
  <Card>
    <Box width="full" justifyContent="center" display="flex">
      <Spinner size={size || "md"} />
    </Box>
  </Card>
);
